import * as THREE from '@phdsoft/three';
import { SensorModel } from "projects/phdsoft/common/src/lib/models/sensor.model";
import { CSS3DObject } from "three/examples/jsm/renderers/CSS3DRenderer.js";
import { WorkableElement } from "../WorkableElement";


export class BasicSensor extends WorkableElement {

  sensorProperties: SensorModel
  target: WorkableElement
  resultBar: THREE.BoxGeometry;
  resultBarMesh: THREE.Mesh;
  barPlotMaterial: THREE.Material;
  depthScale: number =1;
  autoScale: boolean;

  public VerifyProperties() {
    throw new Error("Method not implemented.");
  }

  constructor(mesh: THREE.Mesh, material: THREE.Material, id: string, target: WorkableElement, sensorProperties: SensorModel) {
    super(mesh, material, id);
    this.SectionId = target.SectionId;
    this.regionId = target.regionId;
    this.Guid = id;
    this.sensorProperties = sensorProperties;
    this.elementTypeName = 'BasicSensor';
    this.target = target;


    this.sensorProperties.position = [mesh.position.x, mesh.position.y, mesh.position.z];
    this.sensorProperties.targetId = target.Guid;
    this.sensorProperties.regionId = target.regionId;
    this.sensorProperties.regionName = target.regionName;
    this.sensorProperties.sectionId = target.SectionId;
    this.sensorProperties.sectionName = target.SectionName;

    this.css3dObject = new CSS3DObject(document.createElement('div'));

  }

  public showResultBar(material: THREE.Material){
    this.depthScale = 1;
    this.barPlotMaterial = material;
    this.resultBar = new THREE.BoxGeometry(5,5,1);
    this.resultBar.translate(0,0,0.5);
    this.resultBarMesh = new THREE.Mesh(this.resultBar, material);
    this.SurfaceDesign.add(this.resultBarMesh);
  }

  public hideResultBar(){
    this.SurfaceDesign.remove(this.resultBarMesh);
  }

  public initCSS3DObject(upVector:THREE.Vector3, hasAlarm: boolean, minValue?: number, maxValue?: number){
    // const cssWidth = 100;
    // const cssHeight = 500;
    // const chartDiv = document.createElement('div');
    // chartDiv.style.width = cssWidth+'px';
    // chartDiv.style.height = cssHeight+'px';
    // chartDiv.style.backgroundColor = '#fff';
    // this.myChart = echarts.init(chartDiv);

    // this.myChart.setOption(
    //   {
    //     grid: {
    //       left: 5,
    //       top: 20,
    //       right: 5,
    //       bottom: 20
    //     },
    //     xAxis: {
    //       data: ['Value'],

    //     },
    //     yAxis: {
    //       type: "value",
    //       minorTick: {
    //         show: true
    //       },
    //       minorSplitLine: {
    //         show: true,
    //         lineStyle: {
    //           width: 1,
    //           type: 'dashed'
    //       }

    //       },
    //       axisLabel:{
    //         inside:true,
    //         verticalAlign: 'bottom',
    //         margin:0,
    //         color: '#000'
    //       }
    //     },
    //     series: [
    //       {
    //         name: 'sales',
    //         type: 'bar',
    //         barWidth: '30%',
    //         data: [0]
    //       }
    //     ]
    //   });

    //   if (hasAlarm){
    //     this.autoScale = false;
    //     this.myChart.setOption( {
    //       yAxis:{
    //         min: minValue,
    //         max: maxValue
    //       },
    //       visualMap:{
    //         min:minValue,
    //         max:maxValue,
    //         show:false,
    //         inRange:{
    //           color: ['red', 'yellow', 'green', 'yellow', 'red']
    //         }
    //       }
    //     });
    //   }
		// //stickerDiv.appendChild( symbol );
    // //stickerDiv.appendChild(stickerIcon);
    // this.css3dObject = new CSS3DObject(chartDiv);


    // // sticker.parent = objcss
    // // objcss.element.onclick = () => { alert('document'); }
    // // objcss.element.addEventListener('touch', () => { this.documentsSearchService.download(documentItem) }, false);
    // // objcss.element.addEventListener('click', () => { this.documentsSearchService.download(documentItem) }, false);

    // // objcss.up.copy(this.graphics.camera.up);

    // this.css3dObject.up.copy(upVector);
    // // one 1px in css is 1 wolrd unit
    // const iconsScaleSet = 1/500;
    // this.css3dObject.scale.set(iconsScaleSet, iconsScaleSet, 1);
    // //objcss.lookAt(normal);
    // this.css3dObject.lookAt(this.target.elementNormal.clone());

    // //objcss.position.copy(pos);
    // const xOffset = iconsScaleSet*cssWidth/2;
    // const yOffset = iconsScaleSet*cssHeight/2;


    // this.css3dObject.position.copy(new bVector3(this.sensorProperties.position[0], this.sensorProperties.position[1], this.sensorProperties.position[2]));
    // this.css3dObject.translateY(yOffset);
    // this.css3dObject.translateZ(0.25);

  }

  updateBarPlot(barHeight: number, barMaterial: THREE.Material){
    const oldHeight = this.depthScale/2;
    this.resultBar.translate(0,0,-oldHeight)
    this.resultBar.scale(1,1,barHeight/this.depthScale);
    const newHeight = barHeight/2;
    this.resultBar.translate(0,0,newHeight)
    this.depthScale = barHeight;
    this.resultBarMesh.material = barMaterial;
    // console.log(barMaterial);
    // console.log(barHeight);
    // console.log(this.resultBarMesh)
    // this.myChart.setOption({
    //   series: [
    //     {
    //       data: [sensorReading]
    //     }
    //   ]
    // })
  }



}
